import thumbnail from "./thumbnail.webp";
import section1 from "./section1.webp";
import section2 from "./section2.webp";
import section3 from "./section3.webp";
import mobile1 from "./mobile1.webp";
import mobile2 from "./mobile2.webp";
import mobile3 from "./mobile3.webp";

const LANDING_IMG = {
  THUMBNAIL: thumbnail,
  SECTION1: section1,
  SECTION2: section2,
  SECTION3: section3,
  MOBILE1: mobile1,
  MOBILE2: mobile2,
  MOBILE3: mobile3,
};

export default LANDING_IMG;

